import { Calendar } from "@fullcalendar/core";
import timeGridPlugin from "@fullcalendar/timegrid";
import twLocale from "@fullcalendar/core/locales/zh-tw";
import { Sweet } from "./sweetalert";
import Params from "./getParams";
import { getGymCourse, getFunctionCourse, getGymClosed, getFunctionClosed, getStudents } from "./api";


moment.defineLocale("zh-tw", {
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
});

let quota = null;


document.addEventListener("DOMContentLoaded", function () {

  const calendarEl = document.getElementById("calendar");
  let calendar = new Calendar(calendarEl, {
    plugins: [timeGridPlugin],
    initialView: "timeGridFourDay",
    locale: twLocale,
    height: "100%",
    headerToolbar: {
      left: "prev",
      center: "title",
      right: "next,timeGridWeek,timeGridFourDay",
    },
    views: {
      timeGridFourDay: {
        type: "timeGrid",
        duration: { days: 4 },
        buttonText: "4天",
      },
    },
    titleFormat: { month: "numeric", day: "numeric" },
    slotLabelFormat: function (data) {
      const hourText = moment(data.date.marker)
        .subtract(8, "hours")
        .format("HH:mm");
      return hourText.toString();
    },
    dayHeaderFormat: function (data) {
      const dayNum = moment(data.date.marker)
        .subtract(8, "hours")
        .format("MM/DD");
      const dayText = moment(data.date.marker)
        .subtract(8, "hours")
        .locale("zh-tw")
        .format("dd");
      return `${dayNum}${dayText}`;
    },
    slotMinTime: "08:00:00",
    slotMaxTime: "21:00:00",
    allDaySlot: false,
    eventContent: "",
    eventSources: [
      {
        events: function (fetchInfo, successCallback, failureCallback) {
          const getCourse = Params.isGym ? getGymCourse : getFunctionCourse
          getCourse({
            params: {
              lineId: Params.lineId,
              start: moment(fetchInfo.start).format("YYYY-MM-DD"),
              end: moment(fetchInfo.end).format("YYYY-MM-DD"),
              area: Params.area
            }
          })
            .then(function (response) {
              const res = response.data;
              successCallback(res);
            })
            .catch(function (error) {
              failureCallback(error);
            });
        },
        textColor: "#333",
        borderColor: "#b5c9bc",
      },
      // {
      //   events: function (fetchInfo, successCallback, failureCallback) {
      //     getFunctionCourse()
      //       .then(function (response) {
      //         const res = Params.isGym ? "" : response.data;
      //         successCallback(res);
      //       })
      //       .catch(function (error) {
      //         failureCallback(error);
      //       });
      //   },
      //   textColor: "#333",
      //   borderColor: "#b5c9bc",
      // },
      {
        events: function (fetchInfo, successCallback, failureCallback) {
          const getCloseDay = Params.isGym ? getGymClosed : getFunctionClosed
            getCloseDay({
              params: {
                start: moment(fetchInfo.start).format("YYYY-MM-DD"),
                end: moment(fetchInfo.end).format("YYYY-MM-DD"),
              }
            })
            .then(function (response) {
              const res = Params.isFunction ? "" : response.data;
              successCallback(res);
            })
            .catch(function (error) {
              failureCallback(error);
            });
        },
        textColor: "#333",
        color: "#eeafaf",
      },
      // {
      //   events: function (fetchInfo, successCallback, failureCallback) {
      //     getFunctionClosed()
      //       .then(function (response) {
      //         const res = Params.isGym ? "" : response.data;
      //         successCallback(res);
      //       })
      //       .catch(function (error) {
      //         failureCallback(error);
      //       });
      //   },
      //   textColor: "#333",
      //   color: "#eeafaf",
      // },
    ],
    eventClick: function (info) {
      const vmCalendar = this;

      if (info.event.title == "休館日") {
        info.jsEvent.preventDefault();
      } else {
        Sweet.courseModal(vmCalendar, info.event);
      }
    },
    eventDidMount: function (info) {
      const slotBox = info.el.childNodes[0];
      const isFull = info.event.extendedProps.noStudentQuota;
      const statusText = isFull ? `(額滿)` : "";
      const leftQuota = Number(info.event.extendedProps.studentLimit) - Number(info.event.extendedProps.enrollment)
      const showLeftQuota = (leftQuota <= 2 && leftQuota > 0 )
      const leftQuotaText = showLeftQuota ? `(剩${leftQuota})` : "";
      const teacherText = info.event.extendedProps.teacher
        ? info.event.extendedProps.teacher
        : "";
      const insertHTML = `<div class="course-title">${info.event.title}${leftQuotaText}</div>
      <div class="teacher">${
        Params.isGym ? "" : teacherText
      }<span class="status">${statusText}<span></div>`;
      slotBox.insertAdjacentHTML("beforeend", insertHTML);
    },
    viewDidMount: function (arg) {

      const monthDiv = arg.el.closest(".fc-view-harness");
      getStudents().then(function (response) {
        const data = response.data;
        const showQuotaElements = `<p class='quota'>${Params.isGym ? "體操" : "職能"}
        剩餘可登記堂數： <span id='qNum'>${Params.isGym ? data.gymQuota : data.functionQuota}
        </span></p>`;
        monthDiv.insertAdjacentHTML("beforebegin", showQuotaElements);
      });
    }
  });

  calendar.render();

});


